export default __webpack_public_path__ + "static/media/organiser.a86b5467.png";